import { Translate } from '@components/EventsTimeline/types';
import { IReceivableType } from '@schemas/opsPortal/types/merchantReceivables';

const typeTranslationOverride: Partial<Record<IReceivableType, string>> = {
  ADVANCE_REFUND: 'OPS_PORTAL.TYPE.ADVANCE_REFUND',
  CUSTOMER_REFUND: 'OPS_PORTAL.LABEL.CUSTOMER_REFUND',
  CREDIT_FEE_REFUND: 'OPS_PORTAL.TYPE.CREDIT_FEE_REFUND',
  LATE_FEE: 'OPS_PORTAL.TYPE.LATE_FEE',
  LATE_FEE_REFUND: 'OPS_PORTAL.TYPE.LATE_FEE_REFUND',
  MERCHANT_FEE_REFUND: 'OPS_PORTAL.TYPE.MERCHANT_FEE_REFUND',
  OVERPAYMENT: 'OPS_PORTAL.TYPE.OVERPAYMENT',
  OVERPAYMENT_REFUND: 'OPS_PORTAL.TYPE.OVERPAYMENT_REFUND',
  TERMINATION: 'OPS_PORTAL.TYPE.TERMINATION',
};

export const getTypeTranslation = (
  type: IReceivableType,
  translate: Translate,
) => {
  const key = typeTranslationOverride[type] ?? `TYPE.${type.toUpperCase()}`;
  return translate(key);
};
